const TOKEN_ID_PATTERN = /^#?\s*(\d+)$/

/**
 * Reads a collection search query as a token id. Accepts an optional
 * leading `#` and strips leading zeros. Returns null for anything else.
 */
export const parseTokenIdQuery = (query: string): string | null => {
  const match = TOKEN_ID_PATTERN.exec(query.trim())
  return match ? BigInt(match[1]).toString() : null
}

/** The token ids of one client-side page. */
export const sliceTokenIdPage = (
  tokenIds: string[],
  page: number,
  pageSize: number
): string[] => tokenIds.slice(page * pageSize, (page + 1) * pageSize)

/** True when `loadedPages` pages of `pageSize` do not cover every id. */
export const hasMoreTokenIdPages = (
  tokenIds: string[],
  loadedPages: number,
  pageSize: number
): boolean => loadedPages * pageSize < tokenIds.length
